import { Usuario } from 'components/MenuConta/types'
import HttpClient from './HttpClient'

class UsuarioService {
  async getUsuarioPreferencias() {
    const url = 'usuarios/perfil'

    return HttpClient.get(url)
  }

  async patchUsuarios(usuario: Usuario) {
    const url = 'usuarios/perfil'
    const body = usuario

    return HttpClient.patch(url, body)
  }

  async pegaListaUsuarios(params: URLSearchParams): Promise<{
    usuarios: { nome: string; email: string; idIam: string; sigla: string }[]
    skipToken: string
  }> {
    const url = 'usuarios/vale'

    return HttpClient.get(url, params)
  }
}

export default new UsuarioService()
